@if (service; as svc) {
  <button
    type="button"
    (click)="onClick()"
    class="svc"
    [class.is-selected]="isSelected"
    [attr.aria-pressed]="actionLabel ? null : isSelected"
    [attr.aria-label]="(actionLabel ? actionLabel + ' ' : '') + svc.name + ', ' + (svc.price | currency:'COP':'symbol-narrow':'1.0-0') + (svc.durationMinutes ? ', ' + formatDuration(svc.durationMinutes) : '')">
    @if (svc.imageUrl) {
      <img [src]="svc.imageUrl" alt="" class="svc-image" loading="lazy" />
    }

    <span class="svc-body">
      <span class="svc-line">
        <span class="svc-name">{{ svc.name }}</span>
        <span class="svc-leader" aria-hidden="true"></span>
        <span class="svc-price">{{ svc.price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
      </span>

      @if (svc.description) {
        <span class="svc-description">{{ svc.description }}</span>
      }

      <span class="svc-foot">
        <span class="svc-duration">
          @if (svc.durationMinutes) {
            {{ formatDuration(svc.durationMinutes) }}
          }
        </span>
        @if (actionLabel) {
          <span class="svc-action" aria-hidden="true">{{ actionLabel }}</span>
        } @else if (isSelected) {
          <span class="svc-check" aria-hidden="true">
            <svg class="size-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
            </svg>
            Elegido
          </span>
        }
      </span>
    </span>
  </button>
}
